module.exports = __webpack_public_path__ + "media/img/alhoor-favicon-23c77d15fd3c5f445cd088b43a239c7b.png";